
import { Widget } from './widget';

import BigPlayButton from './big-play-button/BigPlayButton.vue';
import BigUnmuteButton from './big-unmute-button/BigUnmuteButton.vue';
import Claps from './claps/Claps.vue';
import Countdown from './countdown/Countdown.vue';
import InvisibleOverlay from './invisible-overlay/InvisibleOverlay.vue';
import MessageOverlay from './message-overlay/MessageOverlay.vue';
import Overlay from './overlay/Overlay.vue';
import Polls from './polls/Polls.vue';
import Qna from './qna/Qna.vue';
import SeekBar from './seek-bar/SeekBar.vue';
import Shortcuts from './shortcuts/Shortcuts.vue';
import Slides from './slides/Slides.vue';
import Subtitles from './subtitles/Subtitles.vue';
import UserInteractor from './user-interactor/UserInteractor.vue';

export enum PredefinedWidget {
    BigPlayButton = 'big-play-button',
    BigUnmuteButton = 'big-unmute-button',
    Claps = 'claps',
    Countdown = 'countdown',
    MessageOverlay = 'message-overlay',
    InvisibleOverlay = 'invisible-overlay',
    Overlay = 'overlay',
    Polls = 'polls',
    Qna = 'qna',
    SeekBar = 'seek-bar',
    Shortcuts = 'shortcuts',
    Slides = 'slides',
    Subtitles = 'subtitles',
    UserInteractor = 'user-interactor',
}

const splitPaneActiveOnTheRight = ({ isSideBarBelow, hasSplitPanes }: {isSideBarBelow: boolean, hasSplitPanes: boolean}) => {
    if (!hasSplitPanes) {
        return false;
    }
    // on small devices (isSideBarBelow = true), the split pane is below the video, otherwise it's on the right
    return !isSideBarBelow;
};

export default {
    get [PredefinedWidget.BigPlayButton](): Widget {
        return {
            id: PredefinedWidget.BigPlayButton,
            component: BigPlayButton,
            insideVideoElement: () => true
        };
    },

    get [PredefinedWidget.BigUnmuteButton](): Widget {
        return {
            id: PredefinedWidget.BigUnmuteButton,
            component: BigUnmuteButton,
            insideVideoElement: () => true
        };
    },

    get [PredefinedWidget.Claps](): Widget {
        return {
            id: PredefinedWidget.Claps,
            component: Claps,
            insideVideoElement: (args) => !splitPaneActiveOnTheRight(args)
        };
    },

    get [PredefinedWidget.Countdown](): Widget {
        return {
            id: PredefinedWidget.Countdown,
            component: Countdown,
            insideVideoElement: () => true
        };
    },

    get [PredefinedWidget.InvisibleOverlay](): Widget {
        return {
            id: PredefinedWidget.InvisibleOverlay,
            component: InvisibleOverlay,
            insideVideoElement: () => true
        };
    },

    get [PredefinedWidget.MessageOverlay](): Widget {
        return {
            id: PredefinedWidget.MessageOverlay,
            component: MessageOverlay,
            insideVideoElement: () => false
        };
    },

    get [PredefinedWidget.Overlay](): Widget {
        return {
            id: PredefinedWidget.Overlay,
            component: Overlay,
            insideVideoElement: () => true
        };
    },

    get [PredefinedWidget.Qna](): Widget {
        return {
            id: PredefinedWidget.Qna,
            component: Qna,
            insideVideoElement: () => false
        };
    },

    get [PredefinedWidget.Polls](): Widget {
        return {
            id: PredefinedWidget.Polls,
            component: Polls,
            insideVideoElement: () => false
        };
    },

    get [PredefinedWidget.SeekBar](): Widget {
        return {
            id: PredefinedWidget.SeekBar,
            component: SeekBar,
            insideVideoElement: (args) => !splitPaneActiveOnTheRight(args)
        };
    },

    get [PredefinedWidget.Shortcuts](): Widget {
        return {
            id: PredefinedWidget.Shortcuts,
            component: Shortcuts,
            insideVideoElement: () => false
        };
    },

    get [PredefinedWidget.Slides](): Widget {
        return {
            id: PredefinedWidget.Slides,
            component: Slides,
            insideVideoElement: () => true
        };
    },

    get [PredefinedWidget.Subtitles](): Widget {
        return {
            id: PredefinedWidget.Subtitles,
            component: Subtitles,
            insideVideoElement: () => true
        };
    },

    get [PredefinedWidget.UserInteractor](): Widget {
        return {
            id: PredefinedWidget.UserInteractor,
            component: UserInteractor,
            insideVideoElement: () => false
        };
    }
} as Record<string, Widget>;
